import { render } from "./LoginPage.vue?vue&type=template&id=5b0358cd&scoped=true&ts=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=5b0358cd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0358cd"]])

export default __exports__